<template>
    <div class="context common_table_view" ref="common_table_view">
        <div class="header" ref="header">
            <div class="search">
                <div class="search_item">
                    <div class="title"></div>
                    <div class="input_box">
                        <el-input v-model="searchForm.input"
                                  placeholder="请输入姓名或手机号"
                                  class="width_400"
                                  @change="getTableData()"
                                  size="small"
                                  clearable></el-input>
                        <span style="padding-left: 10px">
                        <el-button type="primary"
                                   size="small"
                                   @click="getTableData()">搜索</el-button>
                    </span>
                    </div>
                </div>
                <div class="search_item">
                    <div class="title">状态：</div>
                    <div class="input_box">
                        <div v-for="(item, index) in status_list"
                             :key="index"
                             :class="searchForm.status === item.value?'actived_btn':''"
                             @click="changeCell(item.value, 'status')"
                             class="btn">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <div class="search_item">
                    <div class="title">癌种：</div>
                    <div class="input_box">
                        <div
                            :class="searchForm.tumour_status === ''?'actived_btn':''"
                            @click="changeCell('', 'tumour_status')"
                            class="btn">
                            不限
                        </div>
                        <div v-for="(item, index) in tumour_list"
                             :key="index"
                             :class="searchForm.tumour_status === item.tumour_id?'actived_btn':''"
                             @click="changeCell(item.tumour_id, 'tumour_status')"
                             class="btn">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <div class="search_item">
                    <div class="title">药物：</div>
                    <div class="input_box">
                        <div
                             :class="searchForm.drug_code === ''?'actived_btn':''"
                             @click="changeCell('', 'drug_code')"
                             class="btn">
                            不限
                        </div>
                        <div v-for="(item, index) in drug_code_list"
                             :key="index"
                             :class="searchForm.drug_code === item.drug_code?'actived_btn':''"
                             @click="changeCell(item.drug_code, 'drug_code')"
                             class="btn">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <div class="search_item">
                    <div class="title">注册时间：</div>
                    <el-date-picker
                        v-model="searchForm.regtime"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        @change="getTableData()"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </div>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData"
                      ref="tableFixed"
                      stripe
                      @row-dblclick="goToAudit"
                      width="100%"
                      :height="tableHeight">
                <el-table-column type="index" fixed="left" width="65" label="序号"></el-table-column>
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 :sortable="item.sortable"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
            </el-table>
        </div>

        <div class="bottom_page" ref="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import config from '@/global/config'
    import {clone} from "../../global/utils";

    export default {
        name: "tableView",
        components: {
        },
        data() {
            const showName = (row) => {
                return row.patient_name ? row.patient_name : row.name
            };
            const showSex = (row, column, cellValue, index) => {
              return cellValue == '1'?'男':cellValue=='2'?'女':'未知'
            };
            const showProvince = (row) => {
                return row.province ? row.province + ' / ' + row.city : ''
            };
            const showdrugCode = (row) => {
                let item = this.drug_code_list.find(list => list.drug_code == row.drug_code)
                return item ? item.name : ''
            };
            const showStatus = (row, column, cellValue, index) => {
                return cellValue == '1'?'已注册':
                    cellValue=='2'?'待审核':
                    cellValue=='3'?'已审核':
                    cellValue=='4'?'已拒绝':
                        '未知'
            };
            return {
                tableHeight: 0,
                currentPage: 1,
                pageSize: 50,
                total: 0,

                searchForm: {
                    input: '',
                    status: '',
                    tumour_status: '', //癌种
                    drug_code: '',
                    regtime: []
                },
                status_list: [
                    {name: '不限', value: ''},
                    {name: '已注册', value: '1'},
                    {name: '待审核', value: '2'},
                    {name: '已审核', value: '3'},
                    {name: '已拒绝', value: '4'},
                ],

                tableData: [],
                columnData: [
                    {label: '姓名', prop: 'name', formatter: showName},
                    {label: '性别', prop: 'sex', width: 70, formatter: showSex},
                    {label: '手机号', prop: 'phone'},
                    {label: '关注领域', prop: 'tumour'},
                    {label: '省/市', prop: 'province', formatter: showProvince},
                    {label: '就诊医院', prop: 'hospital'},
                    {label: '注册时间', prop: 'create_time',sortable: true},
                    {label: '使用药物', prop: 'drug_code',formatter: showdrugCode},
                    {label: '首次用药时间', prop: 'first_drug_date'},
                    {label: '医生', prop: 'doctor_name'},
                    {label: '状态', prop: 'status', formatter: showStatus},
                ]
            }
        },
        computed:{
            ...mapState('comInformationData', {
                drug_code_list: 'drug_code_list',
                tumour_list: "tumour_list"
            })
        },
        mounted() {
            this.getTableData()
            this.$eventBus.$on("pollPort",() =>{
                this.getTableData()
            })
            this.$nextTick(() =>{
                this.tableHeight = this.$refs.common_table_view.clientHeight - this.$refs.header.clientHeight - this.$refs.bottom_page.clientHeight
            })
        },
        beforeDestroy() {
            this.$eventBus.$off('pollPort');
        },
        methods: {
            ...mapMutations('illuserData', {
                setIllRow: 'setIllRow'
            }),
            changeCell(item, val) {
                this.searchForm[val] = item;
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1) {
                let params = {
                    page: v,
                    page_size: this.pageSize,
                    name_or_phone: this.searchForm.input,
                    status: this.searchForm.status,
                    drug_code: this.searchForm.drug_code,
                    tumour_status: this.searchForm.tumour_status,
                };
                if (this.searchForm.regtime && this.searchForm.regtime.length > 0) {
                    params.start_date = this.searchForm.regtime[0];
                    params.end_date = this.searchForm.regtime[1];
                }
                // console.log(params, '69');
                this.httpGet('/user/patient', params).then(res => {
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;
                    this.$nextTick(() => {
                        this.currentPage = v
                    });
                    this.$nextTick(() => this.$refs.tableFixed.doLayout())
                });
            },
            goToAudit(row) {
                let ids = [];
                this.tableData.forEach(v => {
                    ids.push(v.patient_id)
                });
                let params = {
                    all: ids,
                    row_id: row.patient_id
                };
                this.setIllRow(params);
                this.$emit('changeTopTab', 'auditView')
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        .search_item{
            .title{
                white-space: nowrap;
            }
        }
    }
</style>